// @flow
import React from "react";
import Select from "react-select";

type DropDownItem = {
  label: string,
  value: number | string
};

type Props = {
  options: Array<DropDownItem>,
  value: ?number | ?string,
  placeholder: ?string,
  onChange: (?DropDownItem) => void,
  width?: number,
  isClearable?: boolean
};

export default class DropDown extends React.Component<Props> {
  customStyles = () => {
    const { width } = this.props;
    return {
      control: (base: Object, state: Object) => ({
        ...base
      })
    };
  };

  render() {
    const { onChange, value, options, placeholder, isClearable } = this.props;
    const selectedValue = value ? options.filter(o => o.value == value) : undefined;

    return (
      <Select
        options={options || []}
        value={selectedValue}
        placeholder={placeholder}
        isMulti={false}
        styles={this.customStyles()}
        id="drop_down_id"
        onChange={onChange}
        isClearable={isClearable}
      />
    );
  }
}

export type { DropDownItem };
